import { configService } from "../index";
import Product from "../../models/product";
import { BaseRequests } from "./BaseRequests";
import { BaseRequestsInterface } from "./BaseRequests";

export default {
  ...BaseRequests(
    () => configService.cellarProducts,
    "product",
    () => new Product()
  )
} as BaseRequestsInterface;
